import React from "react";

import './../../assets/css/style.css'

class Head extends React.Component{
    render(){
        return (
            <head>
            <meta charset="UTF-8" />
            <title>Universo Sig Mobi</title>
            <meta name="robots" content="max-image-preview:large" />
           
            <link
              rel="alternate"
              type="application/rss+xml"
              title="Universo Sig Mobi &raquo; Feed"
              href="./../../assets/feed/"
            />
            <link
              rel="alternate"
              type="application/rss+xml"
              title="Universo Sig Mobi &raquo; Feed de comentários"
              href="./../../assets/comments/feed/"
            />
          {/*
            <link
              rel="stylesheet"
              id="contact-form-7-css"
              href="./../../assets/wp-content/plugins/contact-form-7/includes/css/styles.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="hello-elementor-css"
              href="./../../assets/wp-content/themes/hello-elementor/style.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="hello-elementor-theme-style-css"
              href="./../../assets/wp-content/themes/hello-elementor/theme.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="hello-elementor-header-footer-css"
              href="./../../assets/wp-content/themes/hello-elementor/header-footer.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="elementor-frontend-css"
              href="./../../assets/wp-content/plugins/elementor/assets/css/frontend.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="elementor-post-12-css"
              href="./../../assets/wp-content/uploads/elementor/css/post-12.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="swiper-css"
              href="./../../assets/wp-content/plugins/elementor/assets/lib/swiper/v8/css/swiper.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="e-swiper-css"
              href="./../../assets/wp-content/plugins/elementor/assets/css/conditionals/e-swiper.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="widget-image-css"
              href="./../../assets/wp-content/plugins/elementor/assets/css/widget-image.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="widget-heading-css"
              href="./../../assets/wp-content/plugins/elementor/assets/css/widget-heading.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="widget-text-editor-css"
              href="./../../assets/wp-content/plugins/elementor/assets/css/widget-text-editor.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="e-shapes-css"
              href="./../../assets/wp-content/plugins/elementor/assets/css/conditionals/shapes.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="e-animation-grow-css"
              href="./../../assets/wp-content/plugins/elementor/assets/lib/animations/styles/e-animation-grow.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="widget-image-box-css"
              href="./../../assets/wp-content/plugins/elementor/assets/css/widget-image-box.min.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="elementor-post-57-css"
              href="./../../assets/wp-content/uploads/elementor/css/post-57.css"
              media="all"
            />
            <link
              rel="stylesheet"
              id="google-fonts-1-css"
              href="https://fonts.googleapis.com/css?family=Roboto%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CRoboto+Slab%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CNunito%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CQuestrial%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CPoppins%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic&#038;display=swap&#038;ver=6.7.1"
              media="all"
            />
            */}
            <link rel="preconnect" href="https://fonts.gstatic.com/" crossOrigin />
            <link
              rel="https://api.w.org/"
              href="./../../assets/wp-json/"
            />
            <link
              rel="alternate"
              title="JSON"
              type="application/json"
              href="./../../assets/wp-json/wp/v2/pages/57"
            />
            <link
              rel="EditURI"
              type="application/rsd+xml"
              title="RSD"
              href="https://universosigmobi.com.br/xmlrpc.php?rsd"
            />
            <meta name="generator" content="WordPress 6.7.1" />
            <link rel="canonical" href="https://universosigmobi.com.br/" />
            <link rel="shortlink" href="https://universosigmobi.com.br/" />
            <link
              rel="alternate"
              title="oEmbed (JSON)"
              type="application/json+oembed"
              href="./../../assets/wp-json/oembed/1.0/embed?url=https%3A%2F%2Funiversosigmobi.com.br%2F"
            />
            <link
              rel="alternate"
              title="oEmbed (XML)"
              type="text/xml+oembed"
              href="./../../assets/wp-json/oembed/1.0/embed?url=https%3A%2F%2Funiversosigmobi.com.br%2F&#038;format=xml"
            />
            <meta
              name="generator"
              content="Elementor 3.25.10; features: e_font_icon_svg, additional_custom_breakpoints, e_optimized_control_loading, e_element_cache; settings: css_print_method-external, google_font-enabled, font_display-swap"
            />
           
            <link
              rel="icon"
              href="./../../assets/wp-content/uploads/2024/11/cropped-LOGO-SIG-MOBI-ALTERADO-Post-para-Instagram-4-e1722864121709-150x150.webp"
              sizes="32x32"
            />
            <link
              rel="icon"
              href="./../../assets/wp-content/uploads/2024/11/cropped-LOGO-SIG-MOBI-ALTERADO-Post-para-Instagram-4-e1722864121709-300x300.webp"
              sizes="192x192"
            />
            <link
              rel="apple-touch-icon"
              href="./../../assets/wp-content/uploads/2024/11/cropped-LOGO-SIG-MOBI-ALTERADO-Post-para-Instagram-4-e1722864121709-300x300.webp"
            />
            <link
              rel="alternate"
              type="application/rss+xml"
              title="Universo Sig Mobi &raquo; Feed"
              href="./../../assets/css/main.css"
            />
            <meta
              name="msapplication-TileImage"
              content="./../../assets/wp-content/uploads/2024/11/cropped-LOGO-SIG-MOBI-ALTERADO-Post-para-Instagram-4-e1722864121709-300x300.webp"
            />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, viewport-fit=cover"
            />
{/* 
            <link
              rel="stylesheet"
              id="main-css"
              href="./../../assets/css/style.css"
              media="all"
            /> */}
            <script src="../../assets/js/script_head.js" type="text/javascript"></script>
          </head>
          
        );
    }
}

export default Head;